<template>
  <Loading v-if="componentLoading" :style="style" />
  <Chart v-else-if="visible" class="compare-line-chart" ref="chartComponent" :style="style" :option="chartConfig"></Chart>
</template>

<script lang="ts" setup>
import Chart from "@p-v/packages/Charts/BaseChart/index.vue"
import Loading from "@p-v/packages/Loading.vue"
import { ref } from "vue"
import { cloneDeep, defaultsDeep } from "lodash-es"
import config from "./config"
import type { DataItem, CompareChartProps } from "./index.d"
import { EChartsOption } from "echarts"
import useToggle from "@p-v/hooks/useToggle"

const chartComponent = ref<InstanceType<typeof Chart>>()
const componentLoading = ref<boolean>(true)

const props = withDefaults(defineProps<CompareChartProps>(), {
  dataList: () => [],
  style: () => ({}),
  show: () => true,
  showSymbol: () => false,
})

const { visible, show, hide, changeVisible } = useToggle(props.show)

const chartConfig = ref<any>(cloneDeep(config))
/**
 * 数据处理
 * @param config
 * @param dataList
 */
function componentPropEngine(opt: { dataList: DataItem[]; config?: EChartsOption }) {
  let configResult = cloneDeep(config)

  configResult = defaultsDeep(opt.config, configResult)

  const mainData = opt.dataList[0]
  const compareData = opt.dataList[1]

  let maxValue = Math.max(...mainData.data, ...compareData.data)
  maxValue = Math.ceil(maxValue / 100) * 100
  const interval = maxValue / 5

  // 配置主轴和对比轴
  configResult.yAxis[0].data = compareData.axis
  configResult.yAxis[1].data = mainData.axis
  configResult.xAxis[0].name = compareData.name
  configResult.xAxis[1].name = mainData.name
  configResult.xAxis[0].max = maxValue
  configResult.xAxis[1].max = maxValue
  configResult.xAxis[0].interval = interval
  configResult.xAxis[1].interval = interval
  // 配置分割线

  // 配置legend
  configResult.legend.data = [mainData.name, compareData.name]

  // 配置数据
  configResult.series[1] = defaultsDeep(
    {
      name: mainData.name,
      type: mainData.type,
      data: mainData.data,
      ...mainData.opt,
    },
    configResult.series[1],
  )

  configResult.series[0] = defaultsDeep(
    {
      name: compareData.name,
      type: compareData.type,
      data: compareData.data,
      ...compareData.opt,
    },
    configResult.series[0],
  )

  if (props.showSymbol) {
    configResult.series[0].symbol = "circle"
    configResult.series[0].symbolSize = 10
    configResult.series[1].symbol = "circle"
    configResult.series[1].symbolSize = 10
  }

  // 移除暂无数据的文本
  configResult.graphic[0].invisible = true

  console.log(configResult)

  chartConfig.value = configResult
}

const loading = () => {
  componentLoading.value = true
}
const setData = (
  data:
    | [DataItem, DataItem]
    | {
        dataList: [DataItem, DataItem]
        config?: EChartsOption
      },
  option?: EChartsOption,
) => {
  componentLoading.value = false
  if (Array.isArray(data)) {
    componentPropEngine({ dataList: data, config: option })
  } else {
    componentPropEngine(data)
  }
}
defineExpose({ setData, loading, show, hide, changeVisible })
</script>

<style lang="scss">
.compare-line-chart {
  height: 100%;
}
</style>
